// extracted by mini-css-extract-plugin
module.exports = {"label":"Form_label__3L04W","header":"Form_header__2kUHb","ergCell":"Form_ergCell__8Wj9-"};